export default {"src":"/_next/static/media/gym.9f5c59ff.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};